<template>
  <AtomTransition timing="instant">
    <div
      :key="isTakeoverVisible ? 'takeover' : 'hidden'"
      :class="{
        'h-dvh w-dvw bg-white fixed top-0 left-0 z-50 p-4 flex flex-col': isTakeoverVisible,
      }"
    >
      <TButtonClose
        v-if="isTakeoverVisible"
        @click="isTakeoverVisible = false"
      />

      <div :class="{ 'grow min-h-0 overflow-auto': isTakeoverVisible }">
        <slot :is-takeover-visible="isTakeoverVisible" />
      </div>
    </div>
  </AtomTransition>
</template>

<script setup lang="ts">
const isTakeoverVisible = defineModel<boolean>('takeover', { default: false })

const { lock, unlock } = useDocumentScrollLock()
watch(isTakeoverVisible, (visible) => {
  if (visible) {
    lock()
  }
  else {
    unlock()
  }
})
</script>
